export * from './dragAndDrop.module';
export * from './draggableHelper.provider';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/~/angular-draggable-droppable/dist/esm/src/index.js
// module id = ../../../../angular-draggable-droppable/dist/esm/src/index.js
// module chunks = 42